import "./login-page.scss";

import cssClasses from "classnames";
import PropTypes from "prop-types";
import React, { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { onLoginSubmitFactory } from "../../services/auth";
import { createUserPool } from "../../services/auth/user-pool";
import { UserContext } from "../contexts/user";
import { AltLayout } from "../../common";

const LoginPage = () => {
  const { initUser } = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();
  const userPool = createUserPool();

  const { from } = location.state || { from: { pathname: "/" } };

  const onLoginSubmit = onLoginSubmitFactory({
    history: {
      push: navigate,
      replace: navigate
    },
    userPool,
    initUser: initUser,
    from
  });

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = e => {
    setError(null);
    e.preventDefault();
    setIsLoggingIn(true);
    onLoginSubmit({ username, password })
      .then(() => {
        setIsLoggingIn(false);
      })
      .catch(err => {
        setIsLoggingIn(false);
        if (Array.isArray(err?.errors)) {
          setError(
            err?.errors?.[0]?.detail ||
              err?.errors?.[0]?.title ||
              err?.errors?.[0]?.message
          );
        } else {
          setError(err.message);
        }
      });
  };

  return (
    <AltLayout pageTitle="" noSidebar>
      <div className="h-full flex-grow flex flex-col items-center justify-center bg-gray-200">
        <form
          className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 w-9/12 md:w-1/2 lg:w-3/12"
          onSubmit={handleSubmit}
        >
          {error && <p className="text-red-500 text-xs italic">{error}</p>}
          <div className="mb-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="username"
            >
              Email
            </label>
            <input
              className={cssClasses({
                "w-full p-2": true,
                error: error !== null
              })}
              id="username"
              type="text"
              placeholder="Email"
              value={username}
              onChange={evt => setUsername(evt.target.value)}
            />
          </div>
          <div className="mb-6">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="password"
            >
              Password
            </label>
            <input
              className={cssClasses({
                "w-full p-2": true,
                error: error !== null
              })}
              id="password"
              type="password"
              placeholder="*********"
              value={password}
              onChange={evt => setPassword(evt.target.value)}
            />
          </div>
          <div className="flex items-center justify-between">
            {isLoggingIn ? (
              <span className="fa-2x mr-3">
                <i className="fa fa-circle-notch fa-pulse text-blue-500" />
              </span>
            ) : (
              <button
                className="bg-blue-500 text-white font-bold py-2 px-4 rounded focus:bg-blue-700 focus:outline-none"
                type="submit"
              >
                {" "}
                Sign In
              </button>
            )}
            {/* <a
              className="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800"
              href="#forgotten-password"
            >
              Forgot Password?
            </a> */}
          </div>
        </form>
        <p className="text-center text-gray-500 text-xs">
          A dad once said &quot;With great power comes great
          responsibility&quot;
        </p>
      </div>
    </AltLayout>
  );
};

LoginPage.propTypes = {
  location: PropTypes.object
};

export default LoginPage;
